module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("content_report", [["a",{"class":"content-report-link"},[["i",{"class":"action-icon inf-icon_flag_23"}],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"Report"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/content/report.tpl
// module id = 1083
// module chunks = 4